export default __webpack_public_path__ + "static/rsvp@2x-08c34de50b831f11194a7d6409ff14ec.png";